var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 78,
    fill: "#a71680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9 37.6l65.4 39c.8.5.8 1.7 0 2.2l-65.4 39c-.9.5-1.9-.1-1.9-1.1v-78c0-1 1.1-1.7 1.9-1.1z",
    fill: "#f9af05"
  })));
}
export default SvgPlay;